import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=d7f8fff0&scoped=true"
import script from "./PermissionList.vue?vue&type=script&lang=ts"
export * from "./PermissionList.vue?vue&type=script&lang=ts"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=d7f8fff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f8fff0",
  null
  
)

export default component.exports